import { mkText } from "./text"

import * as styles from "./HoverShadow.module.css"

const HoverShadow = mkText({ className: styles.hoverShadow })

export default HoverShadow
